import React from "react";
import styled from "@emotion/styled";
import PreviewSection from "../components/PreviewSection";
import CodeBlock from "../components/CodeBlock";
import Footer from "../../../components/footer/Footer";
import ResearchFooter from "../../../components/footer/ResearchFooter";
import {
  fontSize,
  fontWeight,
  spacing,
  border as borderToken,
  text,
} from "@atlas-int/tokens";

const SubSection = styled.div`
  margin-bottom: ${spacing[12]};

  &:last-child {
    margin-bottom: 0;
  }
`;

const SubTitle = styled.h3`
  font-size: ${fontSize.lg};
  font-weight: ${fontWeight.semibold};
  color: ${text.primary};
  margin: 0 0 ${spacing[4]} 0;
`;

const Description = styled.p`
  font-size: ${fontSize.base};
  color: ${text.secondary};
  margin: 0 0 ${spacing[6]} 0;
`;

const FooterContainer = styled.div`
  border: 1px solid ${borderToken.default};
  border-radius: 4px;
  overflow: hidden;
`;

const FooterSection: React.FC = () => (
  <>
    <PreviewSection
      id="footer"
      title="Footer"
      description="Full-page footer with Growth Lab branding, navigation links, social media, and copyright."
    >
      <SubSection>
        <SubTitle>Footer</SubTitle>
        <Description>
          Site-wide footer used on landing, about, FAQ, glossary, and other
          content pages. Includes Growth Lab logo, navigation links, social media
          icons, and copyright bar.
        </Description>
        <FooterContainer>
          <Footer />
        </FooterContainer>
        <CodeBlock
          code={`import { Footer } from "components";

<Footer />`}
        />
      </SubSection>
    </PreviewSection>

    <PreviewSection
      id="research-footer"
      title="ResearchFooter"
      description="Research links section with Viz Hub and Growth Lab references."
    >
      <SubSection>
        <SubTitle>ResearchFooter</SubTitle>
        <Description>
          A supplementary footer section that links to the Growth Lab Viz Hub and
          research publications. Used above the main Footer on content pages.
        </Description>
        <ResearchFooter />
        <CodeBlock
          code={`import { ResearchFooter } from "components";

<ResearchFooter />`}
        />
      </SubSection>
    </PreviewSection>
  </>
);

export default FooterSection;
